import axios from "../api/axios";
import { useAuth } from "../context/AuthProvider";

const useRefreshToken = () => {
  const auth = useAuth();
  const refresh = async () => {
    const response = await axios.get("/refreshToken", {
      withCredentials: true,
    });
    auth.login((prev) => {
      return { ...prev, accessToken: response.data.accessToken };
    });
    return response.data.accessToken;
  };
  return refresh;
};

export default useRefreshToken;
